import React from 'react'
import _ from 'lodash';
import AgTechGrid from '@agtech/web/components/Grids/AgTechGrid';
import { AgTechMoneyFormatter } from '@agtech/web/utilities/AgTechUtilities';
import InvoiceCreationDialog from '../../dialogs/creation/InvoiceCreationDialog';
import { SaleBidder, isSaleBidderTheSame } from '@sales/data/bidders/BidderData';
import BidderLotsListPopUpLink from '../../../bidders/components/buttons/BidderLotsListPopUpLink';
import { SaleContactGridLink } from '../../../contacts/components/buttons/SaleContactButtons';
import { BidderLotSaleReadyForInvoicing } from '@sales/data/invoicing/InvoicingData';
import { getContactFullName } from '@agtech/data/contacts/ContactData';
import { gridItems } from '@agtech/web/components/Grids/Data/AgTechGridProps';

export type InvoiceUnprocessedSalesGridEntity = {
    id: string,
    bidderId: number,
    bidderName: string,
    numberOfLotsToInvoice: number,
    lotPurchaseTotal: number,
    bidderNumber?: string,
    bidderContact?: SaleBidder
}

const InvoiceUnprocessedSalesGrid = (props: { unprocessedSales: BidderLotSaleReadyForInvoicing[] }) => {
    return (
        <AgTechGrid
            header={{
                title: "Sold Lots Not Invoiced"
            }}
            data={{
                itemQuery: gridItems(props.unprocessedSales)
            }}
            columns={[
                {
                    header: "Bidder Number",
                    value: saleSummary => saleSummary.bidder.bidderNumber ?? 'N/A',
                    classes: 'bg-slate-100 centered',
                    width: '140px'
                },
                {
                    header: "Bidder Name",
                    value: saleSummary => saleSummary.bidder.contact ? (
                        <SaleContactGridLink
                            contactId={saleSummary.bidder.contact.id}
                            contactName={getContactFullName(saleSummary.bidder.contact)}
                        />
                    ) : 'N/A',
                },
                {
                    header: "Lots Purchased",
                    value: saleSummary => (
                        <BidderLotsListPopUpLink
                            bidderId={saleSummary.id}
                            content={saleSummary.numberOfLots.toString()}
                            isClickable={saleSummary.numberOfLots > 0}
                        />
                    )
                },
                {
                    header: "Purchase Totals",
                    value: saleSummary => AgTechMoneyFormatter.format(saleSummary.totalPurchasePrice)
                },
                {
                    header: '',
                    width: '120px',
                    classes: 'centered',
                    value: saleSummary => (
                        <InvoiceCreationDialog.Button
                            potentialInvoicee={{
                                bidderId: saleSummary.bidder.id,
                                bidderNumber: saleSummary.bidder.bidderNumber,
                                contactId: saleSummary.bidder.contact?.id
                            }}
                            classes='button-link'
                        />
                    ),
                }
            ]}
            isRowEntityTheSame={(prev, curr) => {
                return isSaleBidderTheSame(prev.bidder, curr.bidder) &&
                    prev.numberOfLots === curr.numberOfLots &&
                    prev.totalPurchasePrice === curr.totalPurchasePrice;
            }}
            searchConfig={{
                options: [
                    {
                        field: 'Bidder Number',
                        value: lot => lot.bidder.bidderNumber ?? 'N/A'
                    },
                    {
                        field: 'Bidder Name',
                        value: lot => lot.bidder.contact ? getContactFullName(lot.bidder.contact) : ''
                    }
                ]
            }}
        />
    )
};

export default InvoiceUnprocessedSalesGrid;